var Industry = "산업";
var Aerospace = "항공 우주";
var Agriculture = "농업";
var Automotive = "자동차";
var Education = "교육";
var Gaming = "게임";
var Government = "정부";
var Healthcare = "의료 서비스";
var Hospitality = "숙박";
var Manufacturing = "제조";
var Mining = "광업";
var Other = "기타";
var Retail = "소매";
var Telecommunications = "통신";
var Travel = "여행";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "컴퓨터 및 전자",
	"Consumer goods": "소비재",
	Education: Education,
	"Financial services": "금융 서비스",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "생명 과학",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "마케팅 및 광고",
	"Media & entertainment": "미디어 및 엔터테인먼트",
	Mining: Mining,
	"Non-profit organization": "비영리기구",
	"Oil & gas": "석유 및 가스",
	Other: Other,
	"Power & utilities": "전력 및 유틸리티",
	"Professional services": "전문 서비스",
	"Real estate & construction": "부동산 및 건설",
	Retail: Retail,
	"Software & internet": "소프트웨어 및 인터넷",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "교통 및 물류",
	Travel: Travel,
	"Wholesale & distribution": "도매 및 유통"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
